import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import styles from './styles.module.scss';

const PopupSelectYear = ({
                           isOpen,
                           onSubmit,
                           close,
                         }) => {
  const [date, setDate] = useState(null);
  const submit = async (value) => {
    if (onSubmit) {
      return await onSubmit(value);
    }
  };
  const handleSubmit = async () => {
    try {
      await submit(date);
    } finally {
      await setDate(null);
      await close();
    }
  };
  const handleSubmitWithoutDate = async () => {
    try {
      await submit(null);
    } finally {
      await setDate(null);
      await close();
    }
  };

  const intl = useIntl();
  const text = intl.formatMessage({
    id: 'selectYear-popup-text',
    defaultMessage: 'Please, select the year'
  });
  const placeholder = intl.formatMessage({
    id: 'selectYear-popup-placeholder',
    defaultMessage: 'select year'
  });
  const selectBtnText = intl.formatMessage({
    id: 'selectYear-popup-buttonSelect',
    defaultMessage: 'Submit'
  });
  const cancelBtnText = intl.formatMessage({
    id: 'selectYear-popup-buttonCancel',
    defaultMessage: 'Cancel'
  });

  const {YearPicker} = DatePicker;
  const yearLimit = dayjs().add(1, 'year').toDate();

  return (
    <Modal
      show={isOpen}
      onHide={close}
    >
      <Modal.Body>
        <h3 className={'bold mb-2'}>{text}</h3>
        <div className={`p-4 w-50 ${styles.datepicker}`}>
          <YearPicker
            className="form-control custom-form-control d-flex"
            placeholder={placeholder}
            onChange={(date) => setDate(date.$y)}
            locale={locale}
            suffixIcon={false}
            clearIcon={false}
            showToday={false}
            disabledDate={(current) => {
                return current && current > yearLimit;
              }
            }
          />
        </div>
        <Button
          className="btn-secondary btn-sm col-3 mx-3 "
          onClick={handleSubmitWithoutDate}
        >
          {cancelBtnText}
        </Button>
        <Button
          className="btn-sm col-3 mx-3 custom-send-button"
          onClick={handleSubmit}
          disabled={!date}
        >
          {selectBtnText}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

PopupSelectYear.propTypes = {
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  close: PropTypes.func,
};

export default PopupSelectYear;
